import messages from './messages.json';

const slash = /\//g;

const getCategoryTitle = (category, hasLocalNews, intl) => category
  && category.title
  && (hasLocalNews
    ? category.title
    : intl
      .formatMessage(
        messages[
          `category.${category.path.replaceAll(slash, '.')}`
        ],
      )
  );

export default getCategoryTitle;
